import Vue from 'vue';
import loginRoutes from './login';
import settingRoutes from './setting';

const authorize = import('@/components/login/authorize'),
	error = import('@/components/error'),
	resetPassword = import('@/components/login/reset-password'),
	resetPasswordLegacy = import('@/components/login/reset-password-legacy'),
	createAccount = import('@/components/create-account'),
	createAccountComplete = import('@/components/create-account-complete'),
	verifyEmail = import('@/components/verify-email'),
	verifyCodeTPA = import('@/components/verify-code-tpa'),
	healup = import('@/components/healup'),
	maintenance = import('@/components/maintenance'),
	optOut = import('@/components/opt-out'),
	linkTwitch = import('@/components/link-twitch');

export default [
	...loginRoutes,
	...settingRoutes,
	{
		path: '/:locale/link/twitch',
		name: 'link-twitch',
		components: {
			body: () => linkTwitch,
		},
	},
	{
		path: '/:locale/reset-password',
		name: 'reset-password',
		components: {
			body: () => resetPassword,
		},
	},
	{
		path: '/:locale/reset-password-legacy',
		name: 'reset-password-legacy',
		components: {
			body: () => resetPasswordLegacy,
		},
	},
	{
		path: '/:locale/authorize',
		name: 'authorize',
		components: {
			body: () => authorize,
		},
	},
	{
		path: '/:locale/create',
		name: 'create-account',
		components: {
			body: () => createAccount,
		},
	},
	{
		path: '/:locale/create/complete',
		name: 'creation-complete',
		components: {
			body: () => createAccountComplete,
		},
	},
	{
		path: '/:locale/healup/:mode?',
		name: 'healup',
		components: {
			body: () => healup,
		},
		props: { body: true },
	},
	{
		path: '/:locale/create-tpa',
		name: 'create-tpa',
		redirect: '/:locale/healup/tpa',
	},
	{
		path: '/:locale/create/verify',
		name: 'verify-email',
		components: {
			body: () => verifyEmail,
		},
	},
	{
		path: '/:locale/create/verify/code-tpa',
		name: 'verify-code-tpa',
		components: {
			body: () => verifyCodeTPA,
		},
	},
	{
		path: '*',
		name: 'error-redirect',
		redirect: (to) => {
			const firstPathSegment = to.path.split('/')[1],
				cookieLang = Vue.cookie.get('i18next') || 'en';
			if (firstPathSegment.length !== 2) {
				window.location = `/${cookieLang}${to.fullPath}`;
				return false;
			}
			return {
				path: `/${cookieLang}/error`,
			};
		},
	},
	{
		path: '/:locale/error',
		name: 'error',
		components: {
			body: () => error,
		},
	},
	{
		path: '/:locale/maintenance',
		name: 'maintenance',
		components: {
			body: () => maintenance,
		},
	},
	{
		path: '/:locale/newsletter/opt-out',
		name: 'opt-out',
		components: {
			body: () => optOut,
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/routes/index.js